var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.item},[_c('p',{staticClass:"black fs32 fw500 mb30"},[_vm._v(_vm._s(_vm.head))]),_c('p',{staticClass:"gray fs18"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }